/** @jsx h */

import { h, render, Component } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import { blueMain as blueMainColor } from '../../../styles/scss/_colors.scss';

class IconTrash extends Component {
    render() {
        const { fill, className, width, height } = this.props;

        return (
            <svg
                className={`apc-svg-icon ${className}`}
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
            >
                <path
                    d="M46.616 6.674c.79 0 1.384.578 1.384 1.348v6.674c0 .706-.593 1.348-1.384 1.348h-3.163V43.06c0 3.465-2.9 6.225-6.393 6.225H12.94c-1.714 0-3.295-.642-4.482-1.797-1.252-1.155-1.91-2.76-1.91-4.428V16.044H3.383c-.79 0-1.384-.642-1.384-1.348V8.022c0-.77.593-1.348 1.384-1.348h12.258V1.348c0-.706.593-1.348 1.384-1.348h15.948c.791 0 1.384.642 1.384 1.348v5.326h12.258zM18.476 2.76v3.915h13.048V2.76H18.476zm26.756 10.525V9.369H4.768v3.915h40.464zm-4.547 29.777V16.044H9.315V43.06c0 .962.396 1.797 1.12 2.503.66.641 1.516.962 2.505.962h24.12c2.043-.064 3.559-1.54 3.625-3.465zm-23.66-.45c-.79 0-1.383-.577-1.383-1.347V21.306c0-.706.593-1.348 1.384-1.348.79 0 1.45.642 1.45 1.348v19.958c0 .77-.66 1.348-1.45 1.348zm7.975 0c-.79 0-1.384-.577-1.384-1.347V21.306c0-.706.593-1.348 1.384-1.348.79 0 1.384.642 1.384 1.348v19.958c0 .77-.593 1.348-1.384 1.348zm7.974 0c-.79 0-1.45-.577-1.45-1.347V21.306c0-.706.66-1.348 1.45-1.348.791 0 1.384.642 1.384 1.348v19.958c0 .77-.593 1.348-1.384 1.348z"
                    fill={fill}
                />
            </svg>
        );
    }
}

IconTrash.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconTrash.defaultProps = {
    fill: blueMainColor,
    className: '',
    width: 20,
    height: 20,
};

export default IconTrash;
